<script>
    import Layout from "../../layouts/auth";
    import appConfig from "@/app.config";

    /**
     * Login component
     */
    export default {
        page: {
            title: "Login",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        components: {
            Layout,
        },
        data() {
            return {};
        },
        computed: {},
        methods: {
            login() {
                this.$auth.loginWithRedirect();
            },
        },
        mounted() {
        },
    };
</script>

<template>
    <Layout>
        <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-5">
                <div class="card overflow-hidden">
                    <div class="bg-soft-primary">
                        <div class="row">
                            <div class="col-7">
                                <div class="text-primary p-4">
                                    <h5 class="text-primary">Welcome Back !</h5>
                                    <p>Sign in to continue to Customer Support.</p>
                                </div>
                            </div>
                            <div class="col-5 align-self-end">
                                <img
                                        src="@/assets/images/profile-img.png"
                                        alt
                                        class="img-fluid"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="card-body py-4 text-center">

                        <a href="#" class="btn btn-primary" @click="login">Login</a>

                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card -->
                <!-- end row -->
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </Layout>
</template>

<style lang="scss" module></style>
